import {
  MarkdownSectionNodeBase,
  type MarkdownSectionNodeOptions,
  type MarkdownSectionNodeStorage,
} from '@heidi/editor/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { MarkdownNativeSectionNodeComponent } from './section-node-component';

export { MarkdownSectionNodeBase };
export type { MarkdownSectionNodeOptions, MarkdownSectionNodeStorage };

/**
 * The interactive markdown-native section node: the React-free kernel
 * (`section-node-base.ts`) plus the app-side `ReactNodeViewRenderer` overlay
 * binding, which stays at this legacy path in v1 (OpenSpec `monorepo-kit-editor`
 * task 4.1 / design D4 — `/core` exposes only React-free schema/factory
 * primitives). `extend` inherits the name, options, storage, input rules, and
 * keyboard shortcuts unchanged, so the frozen canonical stack trace is
 * byte-identical. The node view only mounts in a live editor; headless
 * round-trip/derivation editors never render it.
 *
 * No `problemId` attribute lives on this node: the coding overlay anchors PBC
 * chips by the Assessment & Plan name search (`matchSectionsByIdentity: false`)
 * for every host, and the backend emits no `SectionLink.problem_id`, so the
 * id-based section-identity path was never reachable in production. The attribute
 * (and its `data-problem-id` HTML round-trip) has been removed rather than left
 * as a dead door; `buildSectionIdentityDecorations` still tolerates its absence
 * (reads `null`, falls back to heading-text matching) for its own tests.
 */
export const MarkdownSectionNode = MarkdownSectionNodeBase.extend({
  addNodeView() {
    return ReactNodeViewRenderer(MarkdownNativeSectionNodeComponent);
  },
});
